import { deepSetObject, digObject, toggleArray } from '@domain-group/javascript-utils'

import useUser, { useUserForm } from '@hooks/useUser'

const toggleApplications = (applicationKey, entityState, setEntityState) => {
  const { options } = entityState

  const enabledApplications = digObject(entityState, 'options.enabled_realbase_applications', [])
  const updatedEnabledApplications = toggleArray(enabledApplications, applicationKey)
  const updatedOptions = deepSetObject(options, 'enabled_realbase_applications', updatedEnabledApplications)

  setEntityState({ options: updatedOptions })
}

const useManageUserApplicationsModal = (initUser) => {
  const {
    callbacks: {
      updateUser,
    },
    updating,
    user,
  } = useUser(initUser)

  const userForm = useUserForm(user)
  const { entityState, setEntityState } = userForm

  const enabledRealbaseApplications = digObject(entityState, 'options.enabled_realbase_applications', []).sort()

  return {
    callbacks: {
      toggleApplications: applicationKey => (
        toggleApplications(applicationKey, entityState, setEntityState)
      ),
      updateUser,
    },
    enabledRealbaseApplications,
    updating,
    userForm,
  }
}

export default useManageUserApplicationsModal
